export enum SIGN_UP_PROVIDERS {
  GOOGLE = 'google',
  GITHUB = 'github',
  LINKEDIN = 'linkedin',
  EMAIL_AND_PASSWORD = 'email_and_password',
  INDEED = 'Indeed',
  ZOHO_WEBFORM = 'ZohoWebform',
  DB_Team = 'DBTeam',
}
